module.exports = __webpack_public_path__ + "static/media/regal-rush-blue-bg-gold-300x140.7fe082d0.png";